<template>
  <input
    v-if="isReturningKey"
    :id="`${name}-${index}-${extra_id}`"
    class="form-check-input"
    type="radio"
    :name="temp_name"
    :value="trackBy === null ? index : element[trackBy]"
    :checked="modelValue === (trackBy === null ? index : index[trackBy])"
    @change="updateInput"
  />
  <input
    v-else
    :id="`${name}-${index}-${extra_id}`"
    v-model="value"
    class="text-primary focus:ring-primary active:ring-0 active:ring-offset-0"
    type="radio"
    :name="temp_name"
    :value="trackBy === null ? element : element[trackBy]"
    :checked="modelValue === (trackBy === null ? element : element[trackBy])"
    @change="updateInput"
  />
  <br />
  <label
    class="form-check-label capitalize-first"
    :for="`${name}-${index}-${extra_id}`"
  >
    {{ translatedLabel }}
  </label>
</template>

<script>
export default {
  name: 'LabelButtonRadioWithInput',
  props: {
    extra_id: {},
    attributeLabel: {},
    isShowingKey: {},
    isReturningKey: {},
    index: {},
    modelValue: {},
    defaultValue: {},
    name: {},
    trackBy: {},
    translatable: {},
    translationExtention: {},
    updateInput: {},
    element: {},
    getByKey: {}
  },
  data() {
    return {
      value: this.defaultValue,
      temp_name: this.name + this.extra_id
    }
  },
  computed: {
    translatedLabel() {
      if (this.isShowingKey) {
        if (this.getByKey) {
          return this.$t(
            `${this.translationExtention}.${
              this.trackBy === null
                ? this.index
                : this.element[this.attributeLabel]
            }`
          )
        } else {
          return this.translatable
            ? this.$t(`${this.translationExtention}.${this.element}`)
            : this.element
        }
      } else {
        if (this.translatable) {
          return this.$t(
            `${this.translationExtention}.${
              this.trackBy === null
                ? this.index
                : this.element[this.attributeLabel]
            }`
          )
        } else {
          return this.element[this.attributeLabel]
        }
      }
    }
  }
}
</script>
